import { ConstructorPageType } from '@lentau/constructor/shared/constants';

export const LazyLoadEarlyConstructorRequestCSR: (page: ConstructorPageType) => Promise<() => void> = (
  page: ConstructorPageType
) => import('./early-request').then((m) => () => m.constructorRequest(page));
